import type { Resource } from '../home-preview/model'
import { HUB_LINK_GROUPS, hubLinkGroupFor } from './hubLinks'

// Record types from /api/search keep their own headings; people join the People group.
const RECORD_LABELS: Record<string, string> = {
  Bills: 'Bills', Tasks: 'Tasks', Documents: 'Documents', Leave: 'Leave requests',
  'IT Tickets': 'IT tickets', Calendar: 'Calendar', Memos: 'Memos',
}
const GROUP_LABEL = Object.fromEntries(HUB_LINK_GROUPS.map(group => [group.id, group.label]))

/** Category filters for the grouped search, in display order. */
export const GROUPED_SEARCH_CATEGORIES = ['All', ...HUB_LINK_GROUPS.map(group => group.label), ...Object.values(RECORD_LABELS)]

/** File a search result under the same group the header and home page use. */
export function groupedSearchCategory(item: Resource & { email?: string }): string {
  if (item.email) return GROUP_LABEL.people
  if (item.kind === 'Records' && item.searchCategory && RECORD_LABELS[item.searchCategory]) return RECORD_LABELS[item.searchCategory]
  if (item.searchCategory === 'Admin' || /^\/[^/?#]+\/(admin|settings|approval|reconciliation)(?=[/?#]|$)/.test(item.path)) return GROUP_LABEL.admin
  return GROUP_LABEL[hubLinkGroupFor({ path: item.path, categoryName: item.categoryName, source: item.teamApp ? 'team' : 'service' })]
}

const title = (item: Resource) => item.label.trim().toLowerCase()

/**
 * Drop a My profile tab when a page with the same name also matched
 * ("My leave" once, not twice). Profile fields such as bank details stay.
 */
export function withoutDuplicateTitles<T extends Resource>(items: T[]): T[] {
  const pages = new Set(items.filter(item => item.searchCategory !== 'My Profile').map(title))
  return items.filter(item => item.searchCategory !== 'My Profile' || !pages.has(title(item)))
}
